import { useEffect, useState } from "react";
import { getAdminSettingsApi, updateAdminSettingsApi } from "api/admin";
import { C, Panel, SkeletonRows, Field, inputStyle, primaryBtn } from "./admin_ui";

// 운영 설정 (2026-10-20)
// 탈퇴 후 재가입 제한 일수: 저장하면 서버 가입 검사와 앱·웹의 탈퇴 안내 문구에 바로 반영된다
export default function AdminSettings() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(null); // 서버에서 받은 현재 설정
  const [days, setDays] = useState("");
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    const r = await getAdminSettingsApi();
    if (r?.success) {
      setSaved(r);
      setDays(String(r.rejoinCooldownDays));
    } else {
      setError(r?.error || "조회 실패");
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const max = saved?.rejoinCooldownDaysMax ?? 365;
  const n = Number(days);
  const valid = days.trim() !== "" && Number.isInteger(n) && n >= 0 && n <= max;
  const changed = saved && valid && n !== saved.rejoinCooldownDays;

  const handleSave = async () => {
    if (!valid) return;
    if (!window.confirm(`탈퇴 후 재가입 제한을 ${n}일로 바꾸시겠습니까?\n앱과 웹의 가입 검사와 탈퇴 안내 문구에 바로 반영됩니다.`)) return;
    setBusy(true);
    setNotice("");
    const r = await updateAdminSettingsApi({ rejoinCooldownDays: n });
    setBusy(false);
    if (r?.success) {
      setNotice(`${n}일로 저장했습니다.`);
      load();
    } else {
      alert(r?.error || "저장 실패");
    }
  };

  return (
    <>
      <div>
        <div style={{ fontSize: 24, fontWeight: 800, color: C.ink, letterSpacing: "-0.02em" }}>설정</div>
        <div style={{ marginTop: 4, fontSize: 13, color: C.sub }}>앱과 웹이 함께 쓰는 운영 설정</div>
      </div>

      <Panel title="탈퇴 후 재가입 제한">
        {loading ? (
          <SkeletonRows count={2} />
        ) : error ? (
          <div style={{ fontSize: 13, color: "#991B1B" }}>{error}</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 14, maxWidth: 520 }}>
            <div style={{ fontSize: 13, color: C.body, lineHeight: 1.6 }}>
              탈퇴한 회원은 이 기간이 지나야 다시 가입할 수 있습니다. 같은 로그인 계정이나 같은 휴대폰 번호의 탈퇴 기록을 기준으로 봅니다.
              0일로 두면 바로 다시 가입할 수 있습니다. 기간 안에 가입이 필요한 회원에게는 (주)엠아이솔루션 연락처(070-7575-2057)가 안내됩니다.
            </div>
            <Field label={`재가입 제한 일수 (0~${max}일, 기본 ${saved.rejoinCooldownDaysDefault}일)`}>
              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <input
                  type="number"
                  min={0}
                  max={max}
                  step={1}
                  value={days}
                  onChange={(e) => {
                    setDays(e.target.value);
                    setNotice("");
                  }}
                  style={{ ...inputStyle, width: 140 }}
                />
                <span style={{ fontSize: 14, color: C.body }}>일</span>
                <button
                  type="button"
                  onClick={handleSave}
                  disabled={!changed || busy}
                  style={{ ...primaryBtn, opacity: !changed || busy ? 0.45 : 1, cursor: !changed || busy ? "default" : "pointer" }}
                >
                  {busy ? "저장 중…" : "저장"}
                </button>
              </div>
            </Field>
            {!valid && <div style={{ fontSize: 12, color: "#991B1B" }}>0~{max} 사이의 정수를 입력하세요.</div>}
            {notice && <div style={{ fontSize: 12, color: C.greenDark, fontWeight: 700 }}>{notice}</div>}
            <div style={{ fontSize: 12, color: C.sub }}>
              현재 적용 중: {saved.rejoinCooldownDays}일
              {saved.updateDate ? ` · 마지막 변경 ${saved.updateDate}` : " · 기본값 사용 중"}
            </div>
          </div>
        )}
      </Panel>
    </>
  );
}
